/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'core';
const componentName = 'controller-faults-service';
const prefix = `${moduleName}.${componentName}`;

export const goToLicensingLabel = `${prefix}.goToLicensingLabel`;

export const ENGLISH = {
    [goToLicensingLabel]: 'Go To Licensing',
};
